<template lang="pug">
.placements
  Dropdown(
    v-for="{ id, placement } in placementObjects"
    :key="id"
    :value="placement"
    @input="updatePlacement"
    :opened="openedId === id"
    @opened="openedId = ($event ? id : false)"
  )
  .buttons.text-right
    button.btn.btn-link(
      type="button"
      @click="addPlacement"
      :disabled="disabled"
    )
      i.fa.fa-plus
      |
      | Add issue
</template>

<script>
  import { mapStores } from 'pinia'
  import { useIssuesStore } from '@/stores/issues'
  import { usePublicationsStore } from '@/stores/publications'
  import { useStoryPlacementsStore } from '@/stores/story_placements'
  import Dropdown from './dropdown.vue'

  export default {
    components: {
      Dropdown
    },

    props: {
      storyId: {
        type: Number,
        required: false
      }
    },

    data() {
      return {
        openedId: false
      }
    },

    computed: {
      ...mapStores(useIssuesStore, usePublicationsStore, useStoryPlacementsStore),

      placements() {
        return this.storyPlacementsStore.storyPlacements
      },

      placementObjects() {
        return this.placements.map((placement) => {
          return { id: placement.id, placement }
        })
      },

      disabled() {
        return this.storyPlacementsStore.includesBlank
      }
    },

    async mounted() {
      const { storyId } = this

      await this.publicationsStore.fetchOnce()
      await this.issuesStore.fetchOnce()

      if(storyId) {
        await this.storyPlacementsStore.fetch({ storyId })
      } else {
        this.storyPlacementsStore.reset()
      }
    },

    methods: {
      updatePlacement(event) {
        this.storyPlacementsStore.updateStoryPlacement(event)
      },

      async addPlacement() {
        const { storyId } = this
        await this.storyPlacementsStore.addBlank({ storyId })

        // The new placement always has a null ID initially. And we currently only allow
        // one unsaved placement at a time (that's something to improve later, for sure).
        this.openedId = null
      }
    }
  }
</script>
